import { Link } from "react-router-dom";
import React, {useRef, useState} from "react";
import {textPopUp} from "../../function/swal";
import apiJson from "../../helper/axios";

export const ProductDetailComponent = ({product}) => {
    const [popUpView, setPopUpView] = useState(false);

    const scrollRef = useRef(null);
    const scrollUp = () => {
        if (scrollRef.current) {
            scrollRef.current.scrollBy({
                top: -85,
                behavior: "smooth",
            });
        }
    };

    const scrollDown = () => {
        if (scrollRef.current) {
            scrollRef.current.scrollBy({
                top: 85,
                behavior: "smooth",
            });
        }
    };


    const [selectedImage, setSelectedImage] = useState(`${process.env.REACT_APP_PANEL_WEBSITE_ROUTE}${product?.main_image}`);
    const handleImageClick = (imageSrc) => {
        setSelectedImage(imageSrc);
    };

    const [firstname, setFirstname] = useState('');
    const [lastname, setLastname] = useState('');
    const [email, setEmail] = useState('');
    const [city, setCity] = useState('');
    const [country, setCountry] = useState('');
    const [company, setCompany] = useState('');


    const handleDownload = async (filename, name) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_PANEL_WEBSITE_ROUTE}/api/product/download`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    filename: filename
                }),
            });


            if (!response.ok) {
                throw new Error('Failed to download file');
            }

            const blob = await response.blob();
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = name || 'brochure'; // Default file name if none provided
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(link.href); // Clean up URL
        } catch (err) {
            alert('Failed to download the file. Please try again later.');
        }
    };


    let subscribtionData = localStorage.getItem('subscribtion_data');
    let saveData = JSON.parse(localStorage.getItem('subscribtion_data')) || {};


    const handleSubmit = async (event) => {
        event.preventDefault();

        const postData = new FormData();
        postData.append('firstname', firstname || saveData.firstname || '');
        postData.append('lastname', lastname || saveData.lastname || '');
        postData.append('email', email || saveData.email || '');
        postData.append('city', city || saveData.city || '');
        postData.append('country', country || saveData.country || '');
        postData.append('company', company || saveData.company || '');
        postData.append('type', "download");
        postData.append('from_where', "metal_detector");

        const savePostData = {
            firstname: firstname || saveData.firstname ,
            lastname: lastname || saveData.lastname ,
            email: email || saveData.email ,
            city: city || saveData.city ,
            country: country || saveData.country ,
            company: company || saveData.company ,
            type: "download"
        };
        localStorage.setItem('subscribtion_data', JSON.stringify(savePostData));

        if (!savePostData.firstname || !savePostData.lastname || !savePostData.email) {
            setPopUpView(false)
            return textPopUp('Error', 'Terjadi kesalahan. Pastikan semua field wajib terisi.', 'error');
        }

        try {
            const response = await apiJson.post('/emails-list/save', postData);

            if (response.data.status === 200 || response.status === 200) {
                setFirstname('');
                setLastname('');
                setEmail('');
                setCity('');
                setCountry('');
                setCompany('');

                textPopUp('Success', 'Berhasil mendownload brosur', 'success');

                handleDownload(product?.brochures[0]?.file, product?.name);
                setPopUpView(false)
            }
        } catch (err) {
            setPopUpView(false)
            textPopUp('Error', 'Terjadi kesalahan', 'error');
        }
    };

    const onChangePopUpView = () => {
        setPopUpView(!popUpView);
    };



    const [isOpen, setIsOpen] = useState(false);
    const [selectedImageView, setSelectedImageView] = useState(null);

    const openModal = (imageUrl) => {
        setSelectedImageView(imageUrl);
        setIsOpen(true);
    };

    const closeModal = () => {
        setIsOpen(false);
        setSelectedImageView(null);
    };

    const clearSubscribe = () => {
        localStorage.removeItem('subscribtion_data');
        setPopUpView(false)
    };




    return (
        <>
            <section className={"w-full"}>
                <div className={"w-full mx-auto xl:w-full"}>
                    <div className={"w-full pt-2"}>
                        <div className={"w-11/12 mx-auto"}>
                            <div className={"flex justify-between"}>
                                <div className={"my-auto"}>
                                    <h1 className={"text-3xl my-auto md:text-3xl font-semibold"}>Collections</h1>
                                </div>
                                <div className={"my-auto"}>
                                    <ul className={"flex my-auto gap-3"}>
                                        <li className={"my-auto text-sm text-gray-500"}>
                                            <Link to={"/"}>
                                                <p className={"my-auto font-light hover:text-blue-950"}>HOME</p>
                                            </Link>
                                        </li>
                                        <li className={"my-auto text-sm text-gray-500"}>
                                            <Link to={"/catalog"}>
                                                <p className={"my-auto font-semibold hover:text-blue-950"}>CATALOG</p>
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                        </div>
                        <div className={"w-full my-6 md:mb-10 lg:mb-0 md:mt-4 relative"}>
                            <div className={"w-99 mx-auto clip-custom bg-gray-200"}>
                                <div className={"w-full flex"}>
                                    <div className={"w-full sm:w-10/12 md:w-11/12 lg:w-full xl:w-9/12 sm:mx-auto flex relative"}>
                                        <div className={"absolute left-0 lg:block w-2/12"}>
                                            <div className={"w-9/12  my-4 ms-auto"}>
                                                <div className="flex flex-col items-center w-24 md:w-28">
                                                    <button
                                                        onClick={scrollUp}
                                                        className="mb-2 p-2 bg-white shadow border border-gray-100 rounded-full hover:bg-gray-50"
                                                    >
                                                        <div className={"h-6"}>
                                                            <img className={"h-full object-cover"} src={"/assets/icon/icon-arrow-up.svg"}/>
                                                        </div>
                                                    </button>
                                                    <ul
                                                        ref={scrollRef}
                                                        className="overflow-y-scroll bg-white shadow border-gray-400 scrollbar-hide h-[20rem] w-full border rounded border-white"
                                                        style={{ maxHeight: "15rem" }}
                                                    >
                                                        {/* Item */}
                                                        {product?.product_image?.length === 0? (
                                                            <div
                                                                className={"mx-auto w-20 h-20 rounded-lg object-cover bg-gray-100 animate-pulse cursor-pointer"}
                                                            >
                                                            </div>
                                                        ):(
                                                            <>
                                                                <li  className="my-2 pt-2 pb-1">
                                                                    <div className="bg-white w-20 h-20 mx-auto flex items-center justify-center shadow">
                                                                        <button onClick={() => handleImageClick(`${process.env.REACT_APP_PANEL_WEBSITE_ROUTE}${product?.main_image}`)}>
                                                                            <img
                                                                                className="w-full h-full object-cover"
                                                                                src={`${process.env.REACT_APP_PANEL_WEBSITE_ROUTE}${product?.main_image}`}
                                                                                alt={`Product image of ${product?.name}`}
                                                                            />
                                                                        </button>
                                                                    </div>
                                                                </li>
                                                                {product?.product_image?.map((item, index) => (
                                                                    <li key={index} className="my-2 pt-2 pb-1">
                                                                        <div className="bg-white w-20 h-20 mx-auto flex items-center justify-center shadow">
                                                                            <button onClick={() => handleImageClick(`${process.env.REACT_APP_PANEL_WEBSITE_ROUTE}${item?.image}`)}>
                                                                                <img
                                                                                    className="w-full h-full object-cover"
                                                                                    src={`${process.env.REACT_APP_PANEL_WEBSITE_ROUTE}${item?.image}`}
                                                                                    alt={`Product image of ${item?.id}`}
                                                                                />
                                                                            </button>
                                                                        </div>
                                                                    </li>
                                                                ))}
                                                                {product?.product_specification?.map((item, index) => (
                                                                    <li key={index} className="my-2 pt-2 pb-1">
                                                                        <div className="bg-white w-20 h-20 mx-auto flex items-center justify-center shadow">
                                                                            <button onClick={() => handleImageClick(`${process.env.REACT_APP_PANEL_WEBSITE_ROUTE}${item?.image}`)}>
                                                                                <img
                                                                                    className="w-full h-full object-cover"
                                                                                    src={`${process.env.REACT_APP_PANEL_WEBSITE_ROUTE}${item?.image}`}
                                                                                    alt={`Product image of ${item?.id}`}
                                                                                />
                                                                            </button>
                                                                        </div>
                                                                    </li>
                                                                ))}
                                                            </>
                                                        )}
                                                    </ul>

                                                    {/* Tombol Scroll Down */}
                                                    <button
                                                        onClick={scrollDown}
                                                        className="mt-2 p-2 bg-white shadow border border-gray-100 rounded-full hover:bg-gray-50"
                                                    >
                                                        <div className={"h-6"}>
                                                            <img className={"h-full object-cover"} src={"/assets/icon/icon-arrow-bottom.svg"}/>
                                                        </div>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={"w-full md:w-8/12 md:me-auto lg:me-0 lg:w-11/12  xl:w-9/12 ms-auto"}>
                                            <div className={"hidden lg:block "}>
                                                <div className={"w-full ms-auto bg-white h-full"}>
                                                    <div className={"w-full md:w-10/12 bg-white mx-auto h-prod-img"}>
                                                        <img
                                                            onClick={() => openModal(`${selectedImage}`)} // Buka modal saat gambar diklik
                                                            className="w-full object-cover h-full "
                                                            src={selectedImage} alt="Selected product" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className={"block w-full lg:hidden "}>
                                                <div className={"w-full ms-auto h-full"}>
                                                    <div className={"w-full mx-auto bg-white "}>
                                                        <div className={"h-detail-img-2 bg-white mx-auto"}>
                                                            <img
                                                                onClick={() => openModal(`${selectedImage}`)} // Buka modal saat gambar diklik
                                                                className="w-full object-cover h-full "
                                                                src={selectedImage} alt="Selected product" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <div className={"hidden lg:block "}>
                                        <div className={"w-full  me-auto"}>
                                            <div className={"w-11/12 my-10 me-auto"}>
                                                <div className={"w-11/12 ms-auto pt-2 pb-3 bg-white"}>
                                                    <div className={"w-11/12  border-b-2 border-gray-200 mx-auto"}>
                                                        <div className={"w-full"}>
                                                            <div className={"mt-3"}>
                                                                <p className={"text-md  font-medium  text-red-500"}>{product?.category?.name}</p>
                                                            </div>
                                                        </div>
                                                        <div className={"mt-2 mb-3"}>
                                                            <h1 className={"text-3xl text-gray-800 font-semibold"}>
                                                                {product?.name}
                                                            </h1>
                                                            <h1 className={"text-gray-500 font-light"}>
                                                                {product?.model?.name}
                                                            </h1>
                                                        </div>
                                                    </div>
                                                    <div className={"w-11/12 mt-1 py-1 mx-auto"}>
                                                        <div className={"w-full"}>
                                                            <div className={""}>
                                                                <ul className={"block text-sm"}>
                                                                    <li className={"my-2 md:my-1.5"}>
                                                                        <div className={"w-full flex gap-3"}>
                                                                            <div className={""}>
                                                                                <p className={"font-semibold text-gray-700"}>Tipe : </p>
                                                                            </div>
                                                                            <div>
                                                                                <p className={"font-light text-gray-700"}>{product?.type}</p>
                                                                            </div>
                                                                        </div>
                                                                    </li>
                                                                    <li className={"my-2 md:my-1.5"}>
                                                                        <div className={"w-full flex gap-3"}>
                                                                            <div className={""}>
                                                                                <p className={"font-semibold text-gray-700"}>Model : </p>
                                                                            </div>
                                                                            <div>
                                                                                <p className={"font-light text-gray-700"}>{product?.model?.name}</p>
                                                                            </div>
                                                                        </div>
                                                                    </li>
                                                                    <li className={"mt-2 md:my-1.5"}>
                                                                        <div className={"w-full flex gap-3"}>
                                                                            <div className={""}>
                                                                                <p className={"font-semibold text-gray-700"}>Ketegori : </p>
                                                                            </div>
                                                                            <div>
                                                                                <p className={"font-light text-gray-700"}>{product?.category?.name}</p>
                                                                            </div>
                                                                        </div>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className={"w-11/12 mx-auto"}>
                                                        <div className={"my-4 md:my-2"}>
                                                            <ButtonDetail onchange={onChangePopUpView} product={product} popUpView={popUpView} setPopUpView={setPopUpView} />
                                                        </div>
                                                        <div className={"my-4"}>
                                                            <p className={"text-gray-600 text-xs"}>
                                                                Untuk informasi lebih lanjut mengenai harga, produk mesin dan kebutuhan industri lainnya,
                                                                <br/>
                                                                <br/>
                                                            </p>
                                                            <p className={"text-gray-600 text-xs"}>
                                                                Silakan hubungi kami dengan cara klik tombol berikut :
                                                                <a
                                                                    href="mailto:info@unitek-indonesia.com?subject=Halo PT Unimax, Saya ingin menanyakan tentang..."
                                                                    className="text-gray-700 mx-1 cursor-pointer hover:text-blue-950 font-semibold"
                                                                >
                                                                    Email: info@unitek-indonesia.com
                                                                </a>

                                                                atau melalui

                                                                <a
                                                                    href="https://wa.me/628119001211?text=Halo%20PT%20Unimax,%20Saya%20ingin%20menanyakan%20tentang..."
                                                                    className="text-gray-700 ms-1 cursor-pointer hover:text-blue-950 font-semibold"
                                                                >
                                                                    WhatsApp: (+62) 21 5966 6369
                                                                </a>.
                                                            </p>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>

                                </div>
                            </div>

                            {/*Smal*/}
                            <div className={"block lg:hidden "}>
                                <div className={"w-11/12  lg:ms-0 ms-auto me-auto"}>
                                    <div className={"w-full md:mt-0 mt-0 mb-6 me-auto"}>
                                        <div className={"w-full ms-auto pt-2 md:rounded-md pb-3 md:shadow bg-white"}>
                                            <div className={"w-full md:w-11/12  border-b-2 border-gray-200 mx-auto"}>
                                                <div className={"w-full"}>
                                                    <div className={"my-2"}>
                                                        <p className={"text-md  font-light text-gray-600"}>{product?.category?.name}</p>
                                                    </div>
                                                </div>
                                                <div className={"my-3"}>
                                                    <h1 className={"text-xl text-gray-800 font-semibold"}>
                                                        {product?.name}
                                                    </h1>
                                                    <h1 className={"text-gray-500 font-light"}>
                                                        {product?.category?.name} - {product?.model?.name}
                                                    </h1>
                                                </div>
                                            </div>
                                            <div className={"w-full  md:w-11/12 mx-auto"}>
                                                <div className={"py-3"}>
                                                    <ul className={"block text-md"}>
                                                        <li className={"my-2 md:my-1.5"}>
                                                            <div className={"w-full flex gap-3"}>
                                                                <div className={""}>
                                                                    <p className={"font-semibold text-gray-700"}>Tipe : </p>
                                                                </div>
                                                                <div>
                                                                    <p className={"font-light text-gray-700"}>{product?.type}</p>
                                                                </div>
                                                            </div>
                                                        </li>
                                                        <li className={"my-2 md:my-1.5"}>
                                                            <div className={"w-full flex gap-3"}>
                                                                <div className={"w-full flex gap-3"}>
                                                                    <div className={""}>
                                                                        <p className={"font-semibold text-gray-700"}>Model : </p>
                                                                    </div>
                                                                    <div>
                                                                        <p className={"font-light text-gray-700"}>{product?.model?.name}</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </li>
                                                        <li className={"mt-2 md:my-1.5"}>
                                                            <div className={"w-full flex gap-3"}>
                                                                <div className={""}>
                                                                    <p className={"font-semibold text-gray-700"}>Ketegori : </p>
                                                                </div>
                                                                <div>
                                                                    <p className={"font-light text-gray-700"}>{product?.category?.name}</p>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div className={"w-full md:w-11/12 mx-auto"}>
                                                <div className={"my-4 md:my-2"}>
                                                    <ButtonDetail onchange={onChangePopUpView} product={product} popUpView={popUpView} setPopUpView={setPopUpView} />
                                                </div>
                                                <div className={""}>
                                                    <p className={"text-gray-600 text-sm"}>
                                                        For more information on prices, machine products and other necessities.
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="lg:flex hidden w-full md:w-10/12 ms-auto mx-full md:mt-0 mt-12">
                                        <div className={"w-5/12 md:w-full mt-4 ms-auto"}>
                                            <div className={"bg-main rounded-full py-1 md:py-5"}></div>
                                        </div>
                                        <div className={"w-5/12 md:w-full me-auto"}>
                                            <div className={"bg-main rounded-full py-1 md:py-5"}></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={"w-full md:w-11/12  mx-auto pt-4 mt-0 md:mt-4 pb-2 md:pb-10 lg:pb-4 border-y border-gray-300"}>
                                <div className={"w-11/12 mx-auto md:w-full"}>
                                    <div className={"block "}>
                                        <div className={"w-full"}>
                                            <div className={"my-2 border-b border-gray-100"}>
                                                <h3 className={"text-gray-800  text-xl font-semibold my-2"}>Deskripsi</h3>
                                            </div>
                                            <div className={"w-full"}>
                                                <p className={"text-gray-700  text-md font-normal"}  dangerouslySetInnerHTML={{ __html: product?.description }}></p>
                                            </div>
                                        </div>
                                        <div className="w-full border-t border-gray-100 md:mb-0 mb-5  md:mt-4 mt-6 md:pt-4 pt-6">
                                            <div className={"my-3 md:py-0 py-3 text-center  "}>
                                                <h3 className={"text-gray-800  text-xl font-semibold my-0"}>Kontak Kami</h3>
                                            </div>
                                            <div className={"w-11/12 md:w-10/12   mx-auto"}>
                                                <div className={"w-full pt-6 md:pt-2  rounded-xl"}>
                                                    <ul className={"block md:flex justify-between"}>
                                                        {/* WhatsApp Section */}
                                                        <li className={"gap-4 md:mb-1  mb-4 mx-auto w-full md:w-6/12 lg:w-4/12"}>
                                                            <div className={"w-full"}>
                                                                <div className={"w-full md:w-11/12 mx-auto"}>
                                                                    <div className="flex flex-col w-11/12  mx-auto items-center md:items-center text-center md:text-center">
                                                                        <a
                                                                            href="https://wa.me/628119001211"
                                                                            target="_blank"
                                                                            rel="noopener noreferrer"
                                                                            className="bg-white border border-gray-100 hover:bg-blue-50 w-full text-indigo-600 p-2 md:p-3 rounded-full md:mb-4"
                                                                        >
                                                                            <div className={"flex w-11/12 mx-auto mt-3 gap-3 "}>
                                                                                <div className={"h-6 w-6"}>
                                                                                    <img
                                                                                        className={"h-full w-full"}
                                                                                        src={"/assets/icon/icon-call.svg"}
                                                                                        alt="WhatsApp Icon"
                                                                                    />
                                                                                </div>
                                                                                <div className={"my-auto"}>
                                                                                    <h3 className="font-medium my-auto w-full text-md text-gray-600 mb-2">
                                                                                        WhatsApp Kami
                                                                                    </h3>
                                                                                </div>
                                                                            </div>

                                                                        </a>
                                                                        {/*<div className={"hidden py-0 w-full"}>*/}
                                                                        {/*    <h3 className="font-medium w-full text-md text-gray-700 mb-2">*/}
                                                                        {/*        WhatsApp Kami*/}
                                                                        {/*    </h3>*/}

                                                                        {/*</div>*/}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </li>

                                                        <li className={"gap-4 md:mb-1  mb-4 mx-auto w-full md:w-6/12 lg:w-4/12"}>
                                                            <div className={"w-full"}>
                                                                <div className={"w-full md:w-11/12 mx-auto"}>
                                                                    <div className="flex flex-col w-11/12  mx-auto items-center md:items-center text-center md:text-center">
                                                                        <a
                                                                            href="tel:+622159666369"
                                                                            target="_blank"
                                                                            rel="noopener noreferrer"
                                                                            className="bg-white border border-gray-100 hover:bg-blue-50 w-full text-indigo-600 p-2 md:p-3 rounded-full md:mb-4"
                                                                        >
                                                                            <div className={"flex w-11/12 mx-auto mt-3 gap-3 "}>
                                                                                <div className={"h-6 w-6"}>
                                                                                    <img
                                                                                        className={"h-full w-full"}
                                                                                        src={"/assets/icon/icon-call.svg"}
                                                                                        alt="WhatsApp Icon"
                                                                                    />
                                                                                </div>
                                                                                <div className={"my-auto"}>
                                                                                    <h3 className="font-medium my-auto w-full text-md text-gray-600 mb-2">
                                                                                        Telepon Kami
                                                                                    </h3>
                                                                                </div>
                                                                            </div>
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </li>
                                                        <li className={"gap-4 md:mb-1  mb-4 mx-auto w-full md:w-6/12 lg:w-4/12"}>
                                                            <div className={"w-full"}>
                                                                <div className={"w-full md:w-11/12 mx-auto"}>
                                                                    <div className="flex flex-col w-11/12  mx-auto items-center md:items-center text-center md:text-center">
                                                                        <a
                                                                            href="mailto:info@unitek-indonesia.com"
                                                                            target="_blank"
                                                                            rel="noopener noreferrer"
                                                                            className="bg-white border border-gray-100 hover:bg-blue-50 w-full text-indigo-600 p-2 md:p-3  rounded-full md:mb-4"
                                                                        >
                                                                            <div className={"flex w-11/12 mx-auto mt-3 gap-3 "}>
                                                                                <div className={"h-6 w-6"}>
                                                                                    <img
                                                                                        className={"h-full w-full"}
                                                                                        src={"/assets/icon/icon-mail.svg"}
                                                                                        alt="Email Icon"
                                                                                    />
                                                                                </div>
                                                                                <div className={"my-auto"}>
                                                                                    <h3 className="font-medium my-auto w-full text-md text-gray-600 mb-2">
                                                                                        Email Kami

                                                                                    </h3>
                                                                                </div>
                                                                            </div>
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    </ul>

                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>
            {isOpen && (
                <div
                    className="fixed top-0 left-0 right-0 bottom-0 flex justify-center items-center bg-black bg-opacity-50 z-50"
                    onClick={closeModal}
                >
                    <div className="relative bg-white">
                        <img
                            className="w-93 mx-auto object-cover h-93 "
                            src={selectedImageView}
                            alt="Full View"
                        />
                        <button
                            onClick={closeModal}
                            className="absolute top-0 right-0 m-4 text-white bg-black p-2 rounded-full"
                        >
                            &times;
                        </button>
                    </div>
                </div>
            )}
            {popUpView && (
                <>
                    <div
                        onClick={(e) => setPopUpView(false)}
                        className="fixed top-0 left-0 z-50 w-full min-h-screen bg-gray-800 opacity-50"
                    ></div>
                    <div className="fixed inset-0 z-50 flex items-center justify-center">
                        <div className="bg-white p-6 shadow-lg rounded-md max-w-lg w-full">
                            {subscribtionData === null ||  saveData.firstname === "" ||  saveData.lastname  === "" ||  saveData.email === "" ||  saveData.company === "" ||  saveData.country === "" ? (
                                <>
                                    <div className={"flex justify-between mb-6 pb-3 border-b"}>
                                        <div className="text-center pt-1  border-gray-100">
                                            <h2 className="text-lg font-semibold">Download Brosur</h2>
                                        </div>
                                        <div className={""}>
                                            <button onClick={onChangePopUpView} className={"rounded-full pt-2 pl-2 pr-2 pb-2 bg-white hover:bg-gray-50"}>
                                                <div className={"h-6 w-6 "}>
                                                    <img className={"h-full w-full object-cover"} src={"/assets/icon/icon-menu-close.svg"}/>
                                                </div>
                                            </button>
                                        </div>
                                    </div>
                                        <div className="my-2">
                                            <p className="text-gray-700 font-light text-sm">
                                                Berikut adalah beberapa informasi yang belum ada di database kami. Lengkapi profil Anda agar kami dapat memproses permintaan Anda.
                                            </p>
                                        </div>
                                        <form onSubmit={handleSubmit}>
                                            <div className="block">
                                                <div className="mb-16">
                                                    <div className="w-full my-3 flex gap-3">
                                                        <div className="w-6/12">
                                                            <input
                                                                onChange={(e) => setFirstname(e.target.value)}
                                                                value={firstname}
                                                                className="w-full py-3 text-sm font-light px-3 border border-gray-200 rounded-md"
                                                                placeholder="Nama Depan"
                                                                required
                                                                aria-label="Nama Depan"
                                                            />
                                                        </div>
                                                        <div className="w-6/12">
                                                            <input
                                                                onChange={(e) => setLastname(e.target.value)}
                                                                value={lastname}
                                                                className="w-full py-3 text-sm font-light px-3 border border-gray-200 rounded-md"
                                                                placeholder="Nama Belakang"
                                                                required
                                                                aria-label="Nama Belakang"
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="my-3">
                                                        <input
                                                            onChange={(e) => setEmail(e.target.value)}
                                                            value={email}
                                                            className="w-full py-3 text-sm font-light px-3 border border-gray-200 rounded-md"
                                                            placeholder="Alamat Email"
                                                            type="email"
                                                            required
                                                            aria-label="Alamat Email"
                                                        />
                                                    </div>
                                                    <div className="my-3">
                                                        <input
                                                            onChange={(e) => setCompany(e.target.value)}
                                                            value={company}
                                                            className="w-full py-3 text-sm font-light px-3 border border-gray-200 rounded-md"
                                                            placeholder="Nama Perusahaan"
                                                            required
                                                            aria-label="Nama Perusahaan"
                                                        />
                                                    </div>
                                                    <div className="w-full my-3 flex gap-3">
                                                        <div className="w-6/12">
                                                            <input
                                                                onChange={(e) => setCity(e.target.value)}
                                                                value={city}
                                                                className="w-full py-3 text-sm font-light px-3 border border-gray-200 rounded-md"
                                                                placeholder="Kota"
                                                                required
                                                                aria-label="Kota"
                                                            />
                                                        </div>
                                                        <div className="w-6/12">
                                                            <input
                                                                onChange={(e) => setCountry(e.target.value)}
                                                                value={country}
                                                                className="w-full py-3 text-sm font-light px-3 border border-gray-200 rounded-md"
                                                                placeholder="Negara"
                                                                required
                                                                aria-label="Negara"
                                                            />
                                                        </div>
                                                    </div>

                                                    {/* Warning Message */}
                                                    <div className="my-2">
                                                        <p className="text-red-700 font-semibold text-sm">
                                                            * Semua Kolom Wajib Di-Isi
                                                        </p>
                                                    </div>
                                                </div>

                                                {/* Submit Button */}
                                                <div>
                                                    <button
                                                        type="submit"
                                                        className="btn-main-3 text-center w-full py-3 px-5 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition"
                                                        aria-label="Subscribe"
                                                    >
                                                        <p className="text-sm font-medium">SUBSCRIBE</p>
                                                    </button>
                                                </div>
                                            </div>
                                        </form>
                                    </>
                            ): (subscribtionData) ? (
                                <>
                                    <div className={"flex justify-between mb-6 pb-3 border-b"}>
                                        <div className="text-center py-2 border-gray-100">
                                            <h2 className="text-lg font-semibold">Download Brosur</h2>
                                        </div>
                                        <div className={""}>
                                            <button onClick={onChangePopUpView} className={"rounded-full p-2 bg-white hover:bg-gray-50"}>
                                                <div className={"h-6 w-6 "}>
                                                    <img className={"h-full w-full object-cover"} src={"/assets/icon/icon-menu-close.svg"}/>
                                                </div>
                                            </button>
                                        </div>
                                    </div>

                                    <div className="my-2">
                                        <p className="text-gray-700 font-light text-sm">
                                            Berikut adalah informasi anda yang masih tersimpan perangkat anda sebelumnya.
                                        </p>
                                        <div className={"my-4"}>
                                            <div className={"border px-3 bg-gray-100 py-6 border-gray-100 rounded-lg"}>
                                                <h2 className="text-md text-gray-600 cursor-no-drop font-medium">{saveData?.email}</h2>
                                            </div>
                                        </div>
                                    </div>
                                    <form onSubmit={handleSubmit}>
                                        <div className="block">
                                            <button
                                                type="submit"
                                                className="btn-main-3 text-center w-full py-3 px-5 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition"
                                                aria-label="Subscribe"
                                            >
                                                <p className="text-sm font-medium">Download</p>
                                            </button>
                                        </div>
                                    </form>
                                    <div className="mt-5 mb-2 text-left">
                                        <button onClick={clearSubscribe}  className="text-gray-600 cursor-pointer hover:text-blue-950 font-medium text-sm">
                                            Download dengan email lain?, akan menghapus data anda dipenyimpanan browser
                                        </button>
                                    </div>
                                </>

                            ): (
                                <></>
                            )}
                        </div>
                    </div>
                </>
            )}
        </>
    );
};

const ButtonDetail = ({ onchange}) => {


    return (
        <>
            <div className="w-full md:flex gap-3  text-center justify-between">
                <div className="w-full my-3 md:my-0 md:w-6/12">
                    <button className="btn-main-4 w-full" onClick={onchange}>
                        <div className="flex">
                            <div className={"w-full"}>
                                <p className="text-md lg:text-sm font-semibold">Download Brosur</p>
                            </div>
                        </div>
                    </button>
                </div>
                <div className="w-full my-3 md:my-0 md:w-6/12 ms-auto">
                    <a
                        href="https://wa.me/628119001211?text=Halo%20PT%20Unimax,%20Saya%20ingin%20menanyakan%20tentang..."
                    >
                        <button className="btn-main-4-border w-full">
                            <div className="flex ">
                                <div className={"w-full"}>
                                    <p className="text-md lg:text-sm font-semibold">Hubungi Sales</p>
                                </div>
                            </div>
                        </button>
                    </a>

                </div>
            </div>


        </>
    );
};


export const ProductInformationComponent = ({details}) => {
    return (
        <>
            <section id={"about"} className={"pb-10 border-b border-gray-300"}>
                <div className={""}>
                    <div className={""}>
                        <div className={"w-full flex"}>
                            <div className={"w-full md:w-6/12 pb-3 pt-5  mx-auto"}>
                                <div className={"text-center flex items-center"}>
                                    <div className={"border-r ms-auto pe-3 md:pe-6 border-gray-500"}>
                                        <h1 className={"text-main text-2xl  md:text-3xl font-semibold "}>
                                        Detail
                                        </h1>
                                    </div>
                                    <div className={"md:ps-6 ps-3 me-auto"}>
                                        <h4 className={"text-red-600 font-semibold text-lg"}>
                                            I N F O R M A T I O N
                                        </h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={"w-full"}>
                        <div className={"w-full my-5"}>
                            <div className={"w-11/12 md:w-7/12 mx-auto"}>
                                <div className={"bg-gray-100 border border-gray-200 rounded-lg"}>
                                    <div className={"w-11/12 mx-auto gap-5 md:flex"}>
                                        <div className={"w-full flex gap-3"}>
                                            <div className={"w-full p-3 border-r border-b border-gray-200 md:w-6/12 text-left "}>
                                                {/*{item?.type === "description" && (*/}
                                                    <p className={"text-gray-700 font-semibold"}>
                                                        Deskripsi
                                                    </p>
                                                {/*)}*/}
                                            </div>
                                            <div className={"w-full p-3 border-r border-b border-gray-200 md:w-6/12 text-left"}>
                                                <div className={"w-full ms-auto"}>
                                                    <p className={"text-gray-700 font-medium"}>
                                                        Value
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export const ProductSpectionficationComponent = ({ specification }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);

    const openModal = (imageUrl) => {
        setSelectedImage(imageUrl);
        setIsOpen(true);
    };

    const closeModal = () => {
        setIsOpen(false);
        setSelectedImage(null);
    };

    return (
        <>
            <section id={"about"} className={"py-10 md:py-4"}>
                <div className={"w-11/12 mx-auto"}>
                    <div className={""}>
                        <div className={"w-full flex"}>
                            <div className={"w-full md:w-6/12 pb-3 pt-5  mx-auto"}>
                                <div className={"text-center block md:flex items-center"}>
                                    <div className={"border-r-none md:border-r  ms-auto md:me-0 pe-0 md:pe-6 border-gray-700"}>
                                        <h1 className={"text-main text-2xl  md:text-3xl font-semibold "}>
                                            Specification
                                        </h1>
                                    </div>
                                    <div className={"md:ps-6 ps-0 ms-auto md:ms-0 me-auto"}>
                                        <h4 className={"text-red-600 font-semibold text-md md:text-lg"}>
                                            I N F O R M A T I O N
                                        </h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={"w-full"}>
                        <div className={"md:py-2"}>
                            <div className={"w-full"}>
                                {specification.length === 0 ? (
                                    <div  className={"w-11/12  md:w-full"}>
                                        <div className={"mx-auto w-7/12"}>
                                            <div
                                                className={"mx-auto h-96 rounded-lg object-cover bg-gray-100 animate-pulse cursor-pointer"}
                                                >
                                            </div>
                                        </div>
                                    </div>
                                ): (
                                    <>
                                        {specification?.map((item, index) => {
                                            return (
                                                <div key={index} className={"w-11/12 mx-auto md:w-full"}>
                                                    <div className={"mx-auto"}>
                                                        <img
                                                            className={"mx-auto object-cover cursor-pointer"}
                                                            src={`${process.env.REACT_APP_PANEL_WEBSITE_ROUTE}${item?.image}`}
                                                            alt="Specification"
                                                            onClick={() => openModal(`${process.env.REACT_APP_PANEL_WEBSITE_ROUTE}${item?.image}`)} // Buka modal saat gambar diklik
                                                        />
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Modal untuk menampilkan gambar */}
            {isOpen && (
                <div
                    className="fixed top-0 left-0 right-0 bottom-0 flex justify-center items-center bg-black bg-opacity-50 z-50"
                    onClick={closeModal} // Tutup modal saat area di luar gambar diklik
                >
                    <div className="relative">
                        <img
                            className="w-93 mx-auto object-cover h-93 "
                            src={selectedImage}
                            alt="Full View"
                        />
                        <button
                            onClick={closeModal} // Menutup modal saat tombol close ditekan
                            className="absolute top-0 right-0 m-4 text-white bg-black p-2 rounded-full"
                        >
                            &times;
                        </button>
                    </div>
                </div>
            )}
        </>
    );
};
